// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_State_Class from "../Control.Monad.State.Class/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Halogen_Component from "../Halogen.Component/index.js";
import * as Halogen_Query_HalogenM from "../Halogen.Query.HalogenM/index.js";
import * as Visonum_Cross_AppHTML from "../Visonum.Cross.AppHTML/index.js";
import * as Visonum_Cross_Embed from "../Visonum.Cross.Embed/index.js";
import * as Visonum_Cross_Types_Brand_Visonum from "../Visonum.Cross.Types.Brand.Visonum/index.js";
import * as Visonum_Cross_Views_Chart from "../Visonum.Cross.Views.Chart/index.js";
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM);
var put = /* #__PURE__ */ Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM);
var pure = /* #__PURE__ */ Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM);
var TellNewProps = /* #__PURE__ */ (function () {
    function TellNewProps(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    TellNewProps.create = function (value0) {
        return function (value1) {
            return new TellNewProps(value0, value1);
        };
    };
    return TellNewProps;
})();
var render = function (v) {
    var appCtx = {
        debug: false,
        theme: Visonum_Cross_Types_Brand_Visonum.themeVelocityUI,
        embedOpts: Visonum_Cross_Embed.defaultEmbedOpts
    };
    return Visonum_Cross_AppHTML.toHTML(appCtx)((function () {
        if (v.props instanceof Data_Maybe.Just) {
            return Visonum_Cross_AppHTML.from_(Visonum_Cross_Views_Chart.view(v.props.value0));
        };
        if (v.props instanceof Data_Maybe.Nothing) {
            return Visonum_Cross_AppHTML.none;
        };
        throw new Error("Failed pattern match at Visonum.Cross.Components.StandaloneChart (line 53, column 19 - line 55, column 22): " + [ v.props.constructor.name ]);
    })());
};
var handleQuery = function (v) {
    return discard(put({
        props: new Data_Maybe.Just(v.value0)
    }))(function () {
        return pure(new Data_Maybe.Just(v.value1));
    });
};
var component = /* #__PURE__ */ (function () {
    return Halogen_Component.mkComponent({
        initialState: function (v) {
            return {
                props: Data_Maybe.Nothing.value
            };
        },
        render: render,
        "eval": Halogen_Component.mkEval({
            handleAction: Halogen_Component.defaultEval.handleAction,
            receive: Halogen_Component.defaultEval.receive,
            initialize: Halogen_Component.defaultEval.initialize,
            finalize: Halogen_Component.defaultEval.finalize,
            handleQuery: handleQuery
        })
    });
})();
export {
    TellNewProps,
    component,
    render,
    handleQuery
};
